import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import React, { useEffect } from 'react';
import { matchRoutes, useLocation, useNavigationType, createRoutesFromChildren } from 'react-router';

import { store } from '@core/store';

import { App } from '@app/app';

const isMobile = window.innerWidth < 768;

Sentry.init({
  dsn: 'https://bd4ae2faa62f4749bd71dc01239d54a1@o217106.ingest.sentry.io/4505590642507776',
  tracePropagationTargets: ['localhost', 'https:chamalo.camalo.fr/rest/'],
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      autoInject: !isMobile,
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'system',
      showBranding: false,
      showEmail: false,
      showName: false,
      useSentryUser: {
        name: 'fullName',
      },
      isEmailRequired: false,
      // Icon-only trigger: the text label hid the bottom of the content on desktop.
      triggerLabel: '',
      triggerAriaLabel: 'Signaler un problème',
      formTitle: 'Signaler un problème',
      submitButtonLabel: 'Envoyer',
      cancelButtonLabel: 'Annuler',
      confirmButtonLabel: 'Confirmer',
      isRequiredLabel: '',
      messagePlaceholder: 'Décrivez le problème rencontré...',
      successMessageText: 'Merci pour votre retour !',
      addScreenshotButtonLabel: "Ajouter une capture d'écran",
      removeScreenshotButtonLabel: "Supprimer la capture d'écran",
      nameLabel: 'Nom',
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
